import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { environment } from 'environments/environment';
import { PharmacyDetailsModel, UserWarehouse } from 'app/shared/models/pharmacy';

@Injectable()
export class PharmacyUserService {

    constructor(private _http: HttpClient) { }

    get = (): Observable<PharmacyDetailsModel[]> => {
        return this._http.get<PharmacyDetailsModel[]>(`${environment.queryModel}PharmacyUser/GetPharmacyUsers`);
    }

    getPharmacyUserStaff = (pharmacyId: number): Observable<any[]> => {
        return this._http.get<any[]>(`${environment.queryModel}PharmacyUser/PharmacyUserStaff?pharmacyId=${pharmacyId}`);
    }

    // All warehouses the current logged-in user has access to (no default preference, no userId
    // passed — resolved server-side) via the GET_USER_WAREHOUSES stored procedure.
    getUserWarehouses = (): Observable<UserWarehouse[]> => {
        return this._http.get<UserWarehouse[]>(`${environment.queryModel}PharmacyUser/UserWarehouses`);
    }
}